// Module
var code = "<noscript> <iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-MMJPWHH\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe> </noscript> ";
// Exports
module.exports = code;